module.exports = __webpack_public_path__ + "static/social-share-default-36a7364e8cca47ee80f68f664115400a.png";